import { render, staticRenderFns } from "./boundlessSideband.vue?vue&type=template&id=84d2efc4&scoped=true"
import script from "./boundlessSideband.vue?vue&type=script&lang=js"
export * from "./boundlessSideband.vue?vue&type=script&lang=js"
import style0 from "./boundlessSideband.vue?vue&type=style&index=0&id=84d2efc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d2efc4",
  null
  
)

export default component.exports